import { useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchUserGroupAclsWithCounts } from 'common/services/api/UserGroups/UserGroups.thunk';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const useProcessFetchUserGroupsAclsReportData = (
    tenantId: string | undefined
) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const _handleError = (error: unknown) => {
        const err = error as Error;
        const statusCode = extractStatusCode(err.message);
        handleListFetchError(statusCode, 'User Group ACLs report', enqueueSnackbar);
        setProcessing(false);
    };

    const processFetchUserGroupsAclsReportData = async () => {
        if (!tenantId) return;

        setProcessing(true);

        try {
            return await dispatch(fetchUserGroupAclsWithCounts(tenantId)).unwrap();
        } catch(error) {
            _handleError(error);
            return [];
        } finally {
            setProcessing(false);
        }
    };

    return { processing, processFetchUserGroupsAclsReportData };
};
